import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { InstagramService } from '../../../../core/services/instagram.service';
import { InstagramFeedResponse, InstagramPost } from '../../../../core/models/instagram-post.interface';
import { fadeInUpAnimation } from '../../../../shared/animations';
import { PlatformService } from '../../../../core';

@Component({
  selector: 'app-instagram-feed',
  standalone: true,
  imports: [CommonModule],
  animations: [fadeInUpAnimation],
  templateUrl: './instagram-feed.component.html',
  styleUrls: ['./instagram-feed.component.scss']
})
export class InstagramFeedComponent implements OnInit {
  private instagramService = inject(InstagramService);
  private platformService = inject(PlatformService);
  private cdr = inject(ChangeDetectorRef);

  instagramResponse$: Observable<InstagramFeedResponse> | null = null;
  isLoading = true;
  error: string | null = null;

  ngOnInit(): void {
    this.loadPosts();
  }

  loadPosts(): void {
    this.isLoading = true;
    this.error = null;
    this.cdr.detectChanges();
    
    this.instagramResponse$ = this.instagramService.getPosts(3);
    
    // Gestisci il loading state
    this.instagramResponse$.subscribe({
      next: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.error = 'Impossibile caricare i post Instagram. Riprova più tardi.';
        console.error('Errore nel caricamento dei post Instagram:', err);
        this.cdr.detectChanges();
      }
    });
  }

  openInstagramPost(post: InstagramPost): void {
    if (this.platformService.isBrowser()) {
      window.open(post.permalink, '_blank', 'noopener,noreferrer');
    }
  }

  getTimeAgo(timestamp: string): string {
    if (!this.platformService.isBrowser()) {
      return '';
    }

    const now = new Date();
    const postDate = new Date(timestamp);
    const diffInSeconds = Math.floor((now.getTime() - postDate.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return 'Adesso';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} min fa`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} h fa`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} g fa`;
    } else {
      return postDate.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
    }
  }
}

